<template>
  <div class="footer">
    <b-container class="bv-example-row">
      <b-row class="justify-content-md-center">
        <b-col sm="8">
          <ul>
            <h3 class="quick">Quick Links</h3>
            <li class="list_item" v-for="item in lists" :key="item.id">
              <router-link :to="item.url">{{ item.title + ">>" }}</router-link>
            </li>
          </ul></b-col
        >
        <b-col sm="4">
          <!-- <h3 class="logoTitle">Matrix</h3> -->
          <div>
            <b-img
              src="../images/matrixLogo.png"
              fluid
              alt="Responsive image"
            ></b-img>
          </div>
          <div class="tip">
            ©2022 Meta Services All Rights Reserved.
          </div>
          <div>Company Name: Meta Services</div>

          <div>
            Company address: 1 ST FLOOR, B-7, POLICE FIRE STATION, Sector 2,
            Noida, Gautam Buddha Nagar, Uttar Pradesh, 201301
          </div>
          <div>E-mail: contact@matrixgames.io</div>
          <div>Phone No.: +919729656990</div>
        </b-col>
      </b-row>
    </b-container>
    <!-- <b-row align-h="start">
      <b-col cols="6" class="pl_7">
        <ul>
          <h3 class="quick">Quick Links</h3>
          <li class="list_item" v-for="item in lists" :key="item.id">
            <router-link :to="item.url">{{ item.title + ">>" }}</router-link>
          </li>
        </ul></b-col
      >
      <b-col cols="6" class="pl_7">
        <h3 class="logoTitle">Matrix</h3>
        <div class="tip">
          ©2022 Meta ServicesAll Rights Reserved.
        </div>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
export default {
  name: "",

  data() {
    return {
      lists: [
        {
          id: 1,
          title: "Terms ＆ Conditions",
          url: "terms"
        },
        {
          id: 2,
          title: "Refund Policy",
          url: "refund"
        },
        {
          id: 3,
          title: "Privacy Policy",
          url: "privacy"
        },
        {
          id: 4,
          title: "About Us",
          url: "about"
        },
        {
          id: 5,
          title: "FAQ",
          url: "faq"
        }
      ]
    };
  },
  methods: {
    goRoute(name) {
      console.log("跳转路由");
      this.$router.push({
        name: "terms"
      });
    }
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        // let str;
        // if (val.name.includes("Detail")) {
        //   str = val.name.replace("Detail", "");
        // } else {
        //   str = val.name;
        // }
        // const flag = str.concat("Flag");
        // this[flag] = true;
      },
      deep: true
    }
  }
};
</script>
<style lang="less">
.footer {
  padding: 3vw;
  box-sizing: border-box;
}
.list_item {
  background-color: transparent;
  border: none;
  font-family: Arial;
  cursor: pointer;
  padding: 0.5vw;
  box-sizing: border-box;
}
.quick {
  font-size: 4vw;
  font-family: Arial;
  font-weight: 700;
  color: #000000;
}
.logoTitle {
  font-size: 8vw;
  font-family: Arial;
  font-weight: 700;
  color: #000000;
}
.tip {
  font-size: 1vw;
  font-family: Arial;
  font-weight: 600;
  color: #000000;
}
.pl_7 {
  padding-left: 7vw !important;
  box-sizing: border-box;
}

a {
  color: #000000 !important;
}
@media (max-width: 1980px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1450px !important;
  }
}
ul {
  padding-inline-start: 4vw !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue